export class UserSettings {
  [key: string]: any;
  preferences: EmailPreferences = new EmailPreferences();
  mfaPreferences: MFAPreferences = new MFAPreferences();
}

class EmailPreferences {
  emails = defaultOMEmails;
}

class MFAPreferences {
  email: boolean = false;
}

export const defaultOMEmails = [16, 17, 18, 20];

export const OCDefaultEmails = [17, 18, 20, 27];